import { BoxProps, Card, CardBody, CardHeader, Text } from 'grommet';
import { PropsWithChildren } from 'react';
import { borderRadiusSize } from 'src/theme';

export type RightInfoCardProps = PropsWithChildren & {
  title: string;
  background?: BoxProps['background'];
  cardProps?: BoxProps;
};

export const RightInfoCard = ({ background = 'white', title, cardProps, children }: RightInfoCardProps) => (
  <Card
    background={background}
    round={borderRadiusSize}
    border={{ color: 'light-4', size: '1px' }}
    elevation="none"
    {...cardProps}
  >
    <CardHeader
      background="white"
      border={{ side: 'bottom', color: 'border-divider' }}
      pad={{ horizontal: 'small', vertical: 'xsmall' }}
    >
      <Text weight={600} size="small" color="text-heading">
        {title}
      </Text>
    </CardHeader>
    <CardBody pad="small">{children}</CardBody>
  </Card>
);
